export const getArticles = (state) => (state.articles.articles);
export const getArticle = (state) => (
  state.articles.article
);
export const getErrorMessage = (state) => (state.articles.errorMessage);
